export interface AiAgentMessage {
  id: string
  sender: 'user' | 'assistant'
  text: string
  parsedHtml?: string // Store parsed HTML to avoid re-parsing on every render
  timestamp?: number // Unix ms
  isRegenerating?: boolean
}

export interface AiAgentProps {
  initialMessages?: AiAgentMessage[]
  showTimestamp?: boolean
}

// API Types
export interface ChatHistoryItem {
  role: 'user' | 'assistant'
  content: string
}

export interface ChatRequest {
  query: string
  history: ChatHistoryItem[]
  // New fields (for dev/uat)
  coverIds?: string[] | number[]
  // Old fields (for production backward compatibility)
  policyCodes?: string[]
  insuranceClass?: string
  // Common fields
  env?: string
  userId?: string
  policyIds?: string[] | number[]
  countryCode?: string
}

export interface ChatResponse {
  Answer?: string
  answer?: string
}

export const aiAgentRoles = {
  user: 'user',
  assistant: 'assistant',
}
